import useTranslations from '@/i18n/useTranslations';
import { getFullySoldOutLimitedEditionEntries } from '@/pages/artwork/utils/artworkView.selectors';

import './styles/LimitedEditionSoldOutSummary.css';

function formatDimensions(entry) {
  const width = entry?.width;
  const height = entry?.height;

  if (width && height) {
    return `${width} cm x ${height} cm`;
  }

  return entry?.size ?? entry?.name ?? '-';
}

export default function LimitedEditionSoldOutSummary({ editions = {} }) {
  const t = useTranslations('common.shared.artwork_view.details.limited_edition_summary');
  const soldOutEntries = getFullySoldOutLimitedEditionEntries(editions);

  if (!soldOutEntries.length) {
    return null;
  }

  return (
    <section className="limited-edition-sold-out-summary" aria-label={t('sold_out_title')}>
      <h3 className="limited-edition-sold-out-summary__title">{t('sold_out_title')}</h3>
      <dl className="limited-edition-sold-out-summary__list">
        {soldOutEntries.map(({ key, option }) => (
          <div key={key} className="limited-edition-sold-out-summary__item">
            <dt className="limited-edition-sold-out-summary__size">{formatDimensions(option)}</dt>
          </div>
        ))}
      </dl>
    </section>
  );
}
